import React, { useEffect, useState, useMemo } from "react";
import Reaptcha from "reaptcha";
import ReactModal from "react-modal";
import apiClient from "./utils/apiClient";
import { ErrorMessage, Formik } from "formik";
import Keys from "./data/captcha_keys";
import * as Yup from "yup";
import Header from "./Header";
import Result from "./Result";
import DropDownInput from "./DropDownInput";
import axios from "axios";
import {
  countryCodes,
  noOfPeople,
  timeSlots,
  titles,
  todayTimeSlots
} from "./data/options";
import qs from "qs";
import { addDays, format } from "date-fns";
import { FormattedMessage, useIntl } from "react-intl";
import { zhTW, zhCN, enUS } from "date-fns/locale";

export function generateToken(length = 16) {
  const pool = "abcdefghijklmnopqrstuvwxyz0123456789";
  let str = "";
  let i = length;

  while (i) {
    let idx = Math.floor(Math.random() * pool.length);
    let char = pool[idx];
    str += char;
    i--;
  }

  return str;
}

const customStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(121, 66, 3, 0.9)"
  },
  content: {
    background: "transparent",
    border: "none",
    top: "0px",
    left: "0px",
    right: "0px",
    bottom: "0px"
  }
};

const RegisterSchema = intl =>
  Yup.object().shape({
    salutation: Yup.string().required(
      intl.formatMessage({ id: "error.salutation" })
    ),
    email: Yup.string()
      .required(intl.formatMessage({ id: "error.email" }))
      .email(intl.formatMessage({ id: "error.email" }))
      .max(50, intl.formatMessage({ id: "error.email" })),
    firstName: Yup.string()
      .required(intl.formatMessage({ id: "error.firstName" }))
      .max(100, intl.formatMessage({ id: "error.firstName" }))
      .matches(/^[a-zA-Z\s]+$/, intl.formatMessage({ id: "error.firstName" })),
    lastName: Yup.string()
      .required(intl.formatMessage({ id: "error.lastName" }))
      .max(100, intl.formatMessage({ id: "error.lastName" }))
      .matches(/^[a-zA-Z\s]+$/, intl.formatMessage({ id: "error.lastName" })),
    phone: Yup.string()
      .when("countryCode", {
        is: "852",
        then: Yup.string().matches(
          /^[987654]\d{7}$/,
          intl.formatMessage({ id: "error.phone" })
        )
      })
      .when("countryCode", {
        is: "86",
        then: Yup.string().matches(
          /^\d{11}$/,
          intl.formatMessage({ id: "error.phone" })
        )
      })
      .required(intl.formatMessage({ id: "error.phone" })),
    countryCode: Yup.string(),
    people: Yup.string().required(intl.formatMessage({ id: "error.people" })),
    time: Yup.string().when("date", {
      is: "1",
      then: Yup.string().required(intl.formatMessage({ id: "error.time" }))
    }),
    date: Yup.string().required(intl.formatMessage({ id: "error.date" })),
    pics1: Yup.bool().when("pics2", {
      is: true,
      then: Yup.bool().oneOf([true], intl.formatMessage({ id: "error.pics1" }))
    }),
    pics2: Yup.bool(),
    captcha: Yup.string().required(intl.formatMessage({ id: "error.captcha" }))
  });

function Register({ data }) {
  const intl = useIntl();
  const [key, setKey] = useState(null);
  const [phone, setPhone] = useState(null);
  const [successURL, setSuccessURL] = useState(null);
  const [userid, setUserid] = useState(null);
  const [failURL, setFailURL] = useState(null);
  const [messageId, setMessageId] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [token, setToken] = useState("");
  const [countryCode, setCountryCode] = useState("852");
  const [dates, setDates] = useState({});
  useEffect(() => {
    setKey(Keys[Math.floor(Math.random() * Keys.length)]);
  }, []);

  useMemo(() => {
    const now = new Date();
    const dates = {};

    const locale = intl.locale;
    let l;
    if (locale === "en") {
      l = enUS;
    } else if (locale === "zh-CN") {
      l = zhCN;
    } else {
      l = zhTW;
    }
    [0, 1].forEach(i => {
      dates[`${i}`] = format(addDays(now, i), "yyyy-MM-dd, EEEE", {
        locale: l
      });
    });
    setDates(dates);
  }, [intl.locale]);
  useEffect(() => {
    const { token } = qs.parse(window.location.search.slice(1));
    if (
      token &&
      document.referrer.match(
        /^https?:\/\/([^\/]+\.)?thepaviliafarm360\.com\.hk(\/|$)/i
      )
    ) {
      setToken(token);
    } else {
      setToken(generateToken());
    }
  }, [window.location.search, setToken, document.referrer]);

  useEffect(() => {
    if (token) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "reservation_load",
        token: token,
        project: "TPF3"
      });
    }
  }, [token]);

  if (!data.reservable) {
    return (
      <div className="w-full py-40 text-center lg:w-128 lg:mx-auto lg:my-15 lg:shadow-lg overflow-hidden text-sm">
        <Header />
        {/*<div className="mt-8 p-8">*/}
        {/*  {intl.formatMessage({*/}
        {/*    id: "cannot_reserve_now"*/}
        {/*  })}*/}
        {/*</div>*/}
      </div>
    );
  }

  if (!data.slots || data.slots.length === 0) {
    return (
      <div className="w-full py-40 text-center lg:w-128 lg:mx-auto lg:my-15 lg:shadow-lg overflow-hidden text-sm">
        <Header />
        {/*<div className="mt-8 p-8">*/}
        {/*  {intl.formatMessage({*/}
        {/*    id: "no_slot"*/}
        {/*  })}*/}
        {/*</div>*/}
      </div>
    );
  }

  const enabledDays = [];

  if (
    data.slots.indexOf(9800) !== -1 ||
    data.slots.indexOf(9801) !== -1 ||
    data.slots.indexOf(9802) !== -1 ||
    data.slots.indexOf(9803) !== -1 ||
    data.slots.indexOf(9804) !== -1 ||
    data.slots.indexOf(9805) !== -1 ||
    data.slots.indexOf(9806) !== -1 ||
    data.slots.indexOf(9807) !== -1 ||
    data.slots.indexOf(9808) !== -1 ||
    data.slots.indexOf(9809) !== -1
  ) {
    enabledDays.push("0");
  }
  if (
    data.slots.indexOf(0) !== -1 ||
    data.slots.indexOf(1) !== -1 ||
    data.slots.indexOf(2) !== -1 ||
    data.slots.indexOf(3) !== -1 ||
    data.slots.indexOf(4) !== -1 ||
    data.slots.indexOf(5) !== -1 ||
    data.slots.indexOf(6) !== -1 ||
    data.slots.indexOf(7) !== -1 ||
    data.slots.indexOf(8) !== -1 ||
    data.slots.indexOf(9) !== -1
  ) {
    enabledDays.push("1");
  }

  return (
    <div className="w-full lg:w-128 lg:mx-auto lg:my-15 lg:shadow-lg overflow-hidden text-sm">
      <audio className="hidden" controls autoPlay>
        <source src={require("./assets/Together_1.1.mp3")} type="audio/mpeg" />
      </audio>
      <Header />
      <h1 className="text-center mb-2 my-6">
        <FormattedMessage id="title" />
      </h1>
      <div className="px-5 py-2">
        <div>
          <Formik
            initialValues={{
              email: "",
              firstName: "",
              lastName: "",
              phone: "",
              captcha: "",
              salutation: "",
              people: "",
              date: "",
              time: "",
              pics1: false,
              pics2: false,
              countryCode: "852"
            }}
            validationSchema={RegisterSchema(intl)}
            validateOnBlur={false}
            validateOnChange={false}
            onSubmit={async (values, { setSubmitting, setErrors }) => {
              try {
                const { data: encryptedEmail } = await axios.post(
                  "https://asia-east2-noq-guru.cloudfunctions.net/noq-enc",
                  {
                    email: values.email
                  }
                );
                setUserid(encryptedEmail.data);
                let timeStr;
                if (values.date === "0") {
                  timeStr = intl.formatMessage({
                    id: todayTimeSlots[values.time]
                  });
                } else {
                  timeStr = intl.formatMessage({ id: timeSlots[values.time] });
                }
                const { data: registrationData } = await apiClient.register({
                  key,
                  salutation: values.salutation,
                  firstName: values.firstName,
                  lastName: values.lastName,
                  countryCode: values.countryCode,
                  phone: values.phone,
                  email: values.email,
                  date: dates[values.date],
                  token: token,
                  time: timeStr,
                  captcha: values.captcha,
                  numPeople: values.people,
                  optionId: `${data.day}-${values.time}`,
                  lang: intl.locale
                });
                setPhone(values.phone);
                setCountryCode(values.countryCode);
                setSuccessURL(registrationData.success);
                setFailURL(registrationData.fail);
                setMessageId(registrationData.messageId);
                setShowPopup(true);
                setSubmitting(false);
              } catch (e) {
                console.log(e);
                setErrors({
                  error: "發生問題，請再提交"
                });
                setSubmitting(false);
              }
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue
            }) => (
              <form onSubmit={handleSubmit}>
                <div className="mt-4 flex items-start">
                  <FormattedMessage id="label.salutation">
                    {txt => <label className="w-24 mt-1">{txt}</label>}
                  </FormattedMessage>
                  <div className="relative flex-1 ml-4">
                    <DropDownInput
                      fieldName="salutation"
                      placeholder={intl.formatMessage({
                        id: "please_select"
                      })}
                      options={titles}
                      id="reservation_salutation"
                    />
                  </div>
                </div>
                <ErrorMessage
                  name="salutation"
                  component="div"
                  className="text-red-600 text-xs"
                />
                <div className="mt-4 flex items-start">
                  <FormattedMessage id="label.name">
                    {txt => <label className="w-24 mt-1">{txt}</label>}
                  </FormattedMessage>
                  <div className="flex-1">
                    <div className="flex flex-row">
                      <div className="flex-1 ml-4">
                        <input
                          className="text-input block p-1 border-b border-primary bg-transparent w-full outline-none placeholder-placeholder"
                          type="text"
                          name="firstName"
                          placeholder={intl.formatMessage({
                            id: "placeholder.firstName"
                          })}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.firstName}
                          id="reservation_first_name"
                        />
                        <ErrorMessage
                          name="firstName"
                          component="div"
                          className="text-red-600 text-xs"
                        />
                      </div>

                      <div className="flex-1 ml-4">
                        <input
                          className="text-input block p-1 border-b border-primary bg-transparent w-full outline-none placeholder-placeholder"
                          type="text"
                          name="lastName"
                          placeholder={intl.formatMessage({
                            id: "placeholder.lastName"
                          })}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.lastName}
                          id="reservation_last_name"
                        />
                        <ErrorMessage
                          name="lastName"
                          component="div"
                          className="text-red-600 text-xs"
                        />
                      </div>
                    </div>

                    <div className="text-xs text-remark leading-tight ml-4">
                      <FormattedMessage id="remark.name" />
                    </div>
                  </div>
                </div>
                <div className="mt-4 flex items-start">
                  <FormattedMessage id="label.phone">
                    {txt => <label className="w-24 mt-1">{txt}</label>}
                  </FormattedMessage>
                  <div className="ml-4 flex-1">
                    <div className="flex flex-row items-stretch">
                      <div className="relative w-1/4">
                        <DropDownInput
                          fieldName="countryCode"
                          options={countryCodes}
                          translate={false}
                          id="reservation_mobilecountry"
                          onChange={() => setFieldValue("phone", "")}
                        />
                      </div>
                      <input
                        className="ml-2 text-input block p-1 border-b border-primary bg-transparent outline-none placeholder-placeholder flex-1"
                        type="tel"
                        name="phone"
                        onChange={e => {
                          const v = e.target.value;
                          if (values.countryCode === "86") {
                            if (v.length <= 11) {
                              handleChange(e);
                            }
                          } else {
                            if (v.length <= 8) {
                              handleChange(e);
                            }
                          }
                        }}
                        onBlur={handleBlur}
                        value={values.phone}
                        id="reservation_mobile"
                      />
                    </div>
                    <div className="text-xs text-remark leading-tight">
                      <FormattedMessage id="remark.phone" />
                    </div>
                  </div>
                </div>
                <ErrorMessage
                  name="phone"
                  component="div"
                  className="text-red-600 text-xs"
                />

                <div className="mt-4 flex items-start">
                  <FormattedMessage id="label.email">
                    {txt => <label className="w-24 mt-1">{txt}</label>}
                  </FormattedMessage>
                  <div className="ml-4 flex-1">
                    <input
                      className="text-input block p-1 border-b border-primary bg-transparent w-full outline-none placeholder-placeholder"
                      type="email"
                      name="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      id="reservation_email"
                    />
                  </div>
                </div>
                <ErrorMessage
                  name="email"
                  component="div"
                  className="text-red-600 text-xs"
                />
                <div className="mt-4 flex items-start">
                  <FormattedMessage id="label.people">
                    {txt => <label className="w-24 mt-1">{txt}</label>}
                  </FormattedMessage>
                  <div className="relative flex-1 ml-4">
                    <DropDownInput
                      fieldName="people"
                      placeholder={intl.formatMessage({
                        id: "please_select"
                      })}
                      options={noOfPeople}
                      translate={false}
                      id="reservation_people"
                    />
                  </div>
                </div>
                <ErrorMessage
                  name="people"
                  component="div"
                  className="text-red-600 text-xs"
                />
                <div className="mt-4 flex items-start">
                  <FormattedMessage id="label.date">
                    {txt => <label className="w-24 mt-1">{txt}</label>}
                  </FormattedMessage>
                  <div className="relative flex-1 ml-4">
                    <DropDownInput
                      fieldName="date"
                      placeholder={intl.formatMessage({
                        id: "please_select"
                      })}
                      options={dates}
                      translate={false}
                      id="reservation_date"
                      enabledOptions={enabledDays}
                    />
                  </div>
                </div>
                <ErrorMessage
                  name="date"
                  component="div"
                  className="text-red-600 text-xs"
                />

                {values.date && (
                  <>
                    <div className="mt-4 flex items-start">
                      <FormattedMessage id="label.time">
                        {txt => <label className="w-24 mt-1">{txt}</label>}
                      </FormattedMessage>
                      <div className="relative flex-1 ml-4">
                        <DropDownInput
                          fieldName="time"
                          placeholder={intl.formatMessage({
                            id: "please_select"
                          })}
                          options={
                            values.date === "1" ? timeSlots : todayTimeSlots
                          }
                          enabledOptions={data.slots.map(String)}
                          dependant="date"
                          id="reservation_time"
                        />
                      </div>
                    </div>
                    <ErrorMessage
                      name="time"
                      component="div"
                      className="text-red-600 text-xs"
                    />
                  </>
                )}

                <p className="mt-4 text-xs text-remark flex-1">
                  <FormattedMessage
                    id="label.pics0"
                    values={{
                      tnc: (...chunks) => (
                        <a
                          target="_blank"
                          className="text-primary hover:underline"
                          href={intl.formatMessage({ id: "tnc.link" })}
                        >
                          {chunks}
                        </a>
                      ),
                      pics: (...chunks) => (
                        <a
                          target="_blank"
                          className="text-primary hover:underline"
                          href={intl.formatMessage({ id: "pics.link" })}
                        >
                          {chunks}
                        </a>
                      )
                    }}
                  />
                </p>

                <div>
                  <label className="mt-4 text-xs checkbox flex flex-row">
                    <div className="bg-transparent w-4 h-4 flex justify-center items-center mr-2 border border-primary">
                      <input
                        id="reservation_tickbox1"
                        name="pics1"
                        onChange={() => setFieldValue("pics1", !values.pics1)}
                        className="hidden"
                        type="checkbox"
                        checked={values.pics1}
                      />
                      <svg
                        className="hidden w-4 h-4 text-primary pointer-events-none"
                        viewBox="0 0 172 172"
                      >
                        <g
                          fill="none"
                          strokeWidth="none"
                          strokeMiterlimit="10"
                          fontFamily="none"
                          fontWeight="none"
                          fontSize="none"
                          textAnchor="none"
                        >
                          <path d="M0 172V0h172v172z" />
                          <path
                            d="M145.433 37.933L64.5 118.8658 33.7337 88.0996l-10.134 10.1341L64.5 139.1341l91.067-91.067z"
                            fill="currentColor"
                            strokeWidth="1"
                          />
                        </g>
                      </svg>
                    </div>
                    <p className="select-none text-remark flex-1">
                      <FormattedMessage
                        id="label.pics1"
                        values={{
                          tnc: (...chunks) => (
                            <a
                              target="_blank"
                              className="text-primary hover:underline"
                              href={intl.formatMessage({ id: "tnc.link" })}
                            >
                              {chunks}
                            </a>
                          ),
                          pics: (...chunks) => (
                            <a
                              target="_blank"
                              className="text-primary hover:underline"
                              href={intl.formatMessage({ id: "pics.link" })}
                            >
                              {chunks}
                            </a>
                          )
                        }}
                      />
                    </p>
                  </label>
                  <ErrorMessage
                    name="pics1"
                    component="div"
                    className="text-red-600 text-xs"
                  />
                </div>

                <div>
                  <label className="mt-4 text-xs checkbox flex flex-row">
                    <div className="bg-transparent w-4 h-4 flex justify-center items-center mr-2 border border-primary">
                      <input
                        id="reservation_tickbox2"
                        name="pics2"
                        onChange={() => setFieldValue("pics2", !values.pics2)}
                        className="hidden"
                        type="checkbox"
                        checked={values.pics2}
                      />
                      <svg
                        className="hidden w-4 h-4 text-primary pointer-events-none"
                        viewBox="0 0 172 172"
                      >
                        <g
                          fill="none"
                          strokeWidth="none"
                          strokeMiterlimit="10"
                          fontFamily="none"
                          fontWeight="none"
                          fontSize="none"
                          textAnchor="none"
                        >
                          <path d="M0 172V0h172v172z" />
                          <path
                            d="M145.433 37.933L64.5 118.8658 33.7337 88.0996l-10.134 10.1341L64.5 139.1341l91.067-91.067z"
                            fill="currentColor"
                            strokeWidth="1"
                          />
                        </g>
                      </svg>
                    </div>
                    <p className="select-none text-remark flex-1">
                      <FormattedMessage
                        id="label.pics2"
                        values={{
                          pics: (...chunks) => (
                            <a
                              target="_blank"
                              className="text-primary hover:underline"
                              href={intl.formatMessage({ id: "pics.link" })}
                            >
                              {chunks}
                            </a>
                          )
                        }}
                      />
                    </p>
                  </label>
                  <ErrorMessage
                    name="pics2"
                    component="div"
                    className="text-red-600 text-xs"
                  />
                </div>

                <div className="mt-5 mb-5">
                  {key ? (
                    <Reaptcha
                      sitekey={key}
                      hl={intl.formatMessage({ id: "recaptchaLang" })}
                      onVerify={response => {
                        setFieldValue("captcha", response);
                      }}
                    />
                  ) : null}
                  <ErrorMessage
                    name="captcha"
                    component="div"
                    className="text-red-600 text-xs text-center"
                  />
                </div>

                {errors.error ? (
                  <div className="text-red-600 text-xs text-left">
                    {errors.error}
                  </div>
                ) : null}

                <div className="text-center mb-5">
                  <FormattedMessage
                    id={isSubmitting ? "button.submitting" : "button.submit"}
                  >
                    {txt => (
                      <button
                        disabled={isSubmitting}
                        type="submit"
                        className="text-2xl py-2 px-20 text-primary bg-transparent border border-primary cursor-pointer"
                      >
                        {txt}
                      </button>
                    )}
                  </FormattedMessage>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
      <ReactModal isOpen={showPopup} style={customStyles} ariaHideApp={false}>
        <Result
          countryCode={countryCode}
          phone={phone}
          successURL={successURL}
          failURL={failURL}
          messageId={messageId}
          token={token}
          userid={userid}
        />
      </ReactModal>
    </div>
  );
}

export default Register;
